import {
    UNREAD_NOTIFICATIONS_REQUEST_START,
    UNREAD_NOTIFICATIONS_REQUEST_FAIL,
    UNREAD_NOTIFICATIONS_REQUEST_SUCCESS,
    GET_NOTIFICATIONS_REQUEST_START,
    GET_NOTIFICATIONS_REQUEST_FAIL,
    GET_NOTIFICATIONS_REQUEST_SUCCESS,
    READ_NOTIFICATIONS_REQUEST_START,
    READ_NOTIFICATIONS_REQUEST_FAIL,
    READ_NOTIFICATIONS_REQUEST_SUCCESS,
} from './types';

import { get, put } from '../session/actions';
import moment from "moment";
import { getServicesErrorObj } from '../servicesDowntime/actions';

export const unreadNotificationsRequestStart = () => ({
    type: UNREAD_NOTIFICATIONS_REQUEST_START
});

export const unreadNotificationsRequestFail = () => ({
    type: UNREAD_NOTIFICATIONS_REQUEST_FAIL
});

export const unreadNotificationsRequestSuccess = (payload: any) => ({
    type: UNREAD_NOTIFICATIONS_REQUEST_SUCCESS,
    payload
});

export const UNREAD_NOTIFICATIONS_COUNT_URL: Function = (affiliateNo: string) => (`/v1/affiliate-portal/notifications/unread/affiliates/${affiliateNo}`);

export const getUnreadNotificationsCount = () => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(unreadNotificationsRequestStart());

    //'0202110000364938'
    // const AFFILIATE_NUMBER: String | undefined = ( cookie.get('affiliate-number') );
    const AFFILIATE_NUMBER: string | null = (sessionStorage.getItem('affiliate-number'));

    dispatch(get(UNREAD_NOTIFICATIONS_COUNT_URL(AFFILIATE_NUMBER))).then((response: any) => {
        dispatch(unreadNotificationsRequestSuccess(response.data && response.data.unread_notifications_count))
        resolve(response.data && response.data.unread_notifications_count);
    }).catch((error: any) => {
        dispatch(unreadNotificationsRequestFail());
        dispatch(getServicesErrorObj(error));
        reject();
    })
});

export type NotificationsAction = {
    type: string,
    payload?: any,
}

export const getAllNotificationsRequestStart = () => ({
    type: GET_NOTIFICATIONS_REQUEST_START
});

export const getAllNotificationsRequestFail = () => ({
    type: GET_NOTIFICATIONS_REQUEST_FAIL
});

export const getAllNotificationsRequestSuccess = (payload: any) => ({
    type: GET_NOTIFICATIONS_REQUEST_SUCCESS,
    payload
});

export const GET_ALL_NOTIFICATIONS_URL: Function = (affiliateNo: string) => (
    `/v1/affiliate-portal/notifications/affiliates/${affiliateNo}`
);

export const getAllNotifications = () => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(getAllNotificationsRequestStart());

    const AFFILIATE_NUMBER: string | null = (sessionStorage.getItem('affiliate-number'));

    dispatch(get(GET_ALL_NOTIFICATIONS_URL(AFFILIATE_NUMBER))).then((response: any) => {
        if (response.data && response.data.all_notifications) {
            dispatch(getAllNotificationsRequestSuccess(response.data.all_notifications));
        } else {
            dispatch(getAllNotificationsRequestFail());
        }
        resolve(response.data);
    }).catch((error: any) => {
        dispatch(getAllNotificationsRequestFail());
        dispatch(getServicesErrorObj(error));
        reject();
    });
});

export const readNotificationsRequestStart = (payload: any) => ({
    type: READ_NOTIFICATIONS_REQUEST_START,
    payload
});

export const readNotificationsRequestSuccess = () => ({
    type: READ_NOTIFICATIONS_REQUEST_SUCCESS
});

export const readNotificationsRequestFail = () => ({
    type: READ_NOTIFICATIONS_REQUEST_FAIL
});

export const READ_NOTIFICATIONS_URL: Function = () => (
    `/v1/affiliate-portal/notifications`
);

export const readNotifications = (notificationsIds: object) => (
    dispatch: Function
) => new Promise((resolve, reject) => {
    dispatch(readNotificationsRequestStart(notificationsIds));

    dispatch(put(READ_NOTIFICATIONS_URL(), notificationsIds)).then((response: any) => {
        dispatch(readNotificationsRequestSuccess());
        resolve(response.data);
    }).catch((error: any) => {
        dispatch(readNotificationsRequestFail());
        dispatch(getServicesErrorObj(error));
        reject();
    });
});